import styles from "./styles.module.scss";
import ModalLayout, { DockPosition } from "components/ModalLayout";
import { useContext, useEffect, useMemo, useState } from "react";
import ModalsManagerContext from "contexts/ModalsManager";
import { IPackage } from "dto/IPackage";
import PackagesContext from "contexts/PackagesContext";
import { getCompanyId as getWorkspaceId } from "utils/getCompanyId";
import CloseIcon from "assets/icons/close.svg?react";
import tagsService from "api/tagsService";
import { ITag, TagType } from "dto/ITag";
import ChooseTagNew from "components/ChooseTagNew";
import CasesContext from "contexts/CasesContext";
import { ICase } from "dto/Cases/ICase";

const EditStatuModal = () => {
  const currentWorkspaceId = getWorkspaceId();

  const [tagType, setTagType] = useState(TagType.Incoming);
  const { data: tagsData } = tagsService.useGetTags(
    false,
    tagType,
    undefined,
    currentWorkspaceId ?? "",
  );
  const allTags = useMemo(
    () => tagsData?.data ?? [],
    [tagsData, tagsData?.data],
  );
  const [, setTags] = useState<ITag[]>([]);
  const [pack, setPack] = useState<IPackage | null>(null);
  const { packages, setPackages } = useContext(PackagesContext);
  const { cases, setCases } = useContext(CasesContext);
  const { modals, setModals } = useContext(ModalsManagerContext);
  const [packageType, setPackageType] = useState("PACKAGE");

  const closeModal = () => {
    setModals({ ...modals, hide: true });
  };

  useEffect(() => {
    const item = localStorage.getItem("package");
    const type = localStorage.getItem("packageType");
    if (!item) return;
    setPack(JSON.parse(item));
    if (!type) return;
    setPackageType(type);

    if (type === "CASE") {
      setTagType(TagType.Cases);
    }

    localStorage.removeItem("packageType");
  }, []);

  useEffect(() => {
    if (!pack) return;

    setTags(allTags.filter((t: ITag) => (pack.TagIds ?? []).includes(t.Id)));
  }, [pack, allTags]);

  const handleTags = (tags: ITag[]) => {
    const newPacks = packageType === "CASE" ? [...cases] : [...packages];
    setTags(tags);
    const el = newPacks.find((c) => c.Id === pack.Id && c.Kind === pack.Kind);

    if (el) {
      el.TagIds = tags.map((t) => t.Id);
    }

    if (packageType === "CASES") {
      setCases(newPacks as ICase[]);
    } else {
      setPackages(newPacks as IPackage[]);
    }
  };

  return (
    <ModalLayout
      dock={DockPosition.DISABLED}
      off={true}
      customX={8}
      customY={0}
      ignore
      isAnimation
      fullHeight={true}
      name="setTagModal"
    >
      <div className={styles.wrapper}>
        <div className={styles.title}>
          Etykieta
          <CloseIcon
            onClick={() => {
              closeModal();
            }}
            className={styles.closeIcon}
          />
        </div>
        <div className={styles.content}>
          <ChooseTagNew
            updateTags={handleTags}
            type={tagType}
            toTag={pack}
            isTask={false}
            className={styles.clearModal}
          />
        </div>
      </div>
    </ModalLayout>
  );
};

export default EditStatuModal;
